import {
  PC_SUBSCRIPTION_ID,
  MARIS_PICKS_SUBSCRIPTION_ID,
  MINIMUM_CART_QUANTITY_FOR_PC_AUTO_ENROLL,
} from './constants';

import CartTogglePCMembershipMutation from '../../../mutationsModern/Cart/CartTogglePCMembershipMutation';
import CartToggleAutoshipMutation from '../../../mutationsModern/Cart/CartToggleAutoshipMutation';
import CartAdjustAutoshipMutation from '../../../mutationsModern/Cart/CartAdjustAutoshipMutation';
import CartAddMutation from '../../../mutationsModern/Cart/CartAddMutation';

import { environment } from '../../../environment';

const initialState = {
  isUserPc: false,
  enrollingAsPc: false,
  autoshipEnabled: false,
  showAutoShip: true,
  autoEnrollPC: true,
  autoShipIntervalCount: 4,
  autoShipIntervalUnit: 'week',
  totalNumberOfItems: 0,
  viaQualifiedCartTotal: 0,
  environment: null,
};

export const TOGGLE_PC_ENROLL = 'TOGGLE_PC_ENROLL';
export const TOGGLE_PC_AUTOSHIP = 'TOGGLE_PC_AUTOSHIP';
export const TOGGLE_PC_AUTOENROLL = 'TOGGLE_PC_AUTOENROLL';
export const SET_AUTOSHIP_COUNT = 'SET_AUTOSHIP_COUNT';
export const SET_AUTOSHIP_INTERVAL = 'SET_AUTOSHIP_INTERVAL';
export const RESET_CART = 'RESET_CART';
export const SHOW_AUTOSHIP = 'SHOW_AUTOSHIP';

const ACTION_HANDLERS = {
  [TOGGLE_PC_ENROLL]: (state, action) => ({
    ...state,
    enrollingAsPc: action.enrollingAsPc,
  }),
  [TOGGLE_PC_AUTOSHIP]: (state, action) => ({
    ...state,
    autoshipEnabled: action.autoshipEnabled,
  }),
  [TOGGLE_PC_AUTOENROLL]: state => ({
    ...state,
    autoEnrollPC: !state.autoEnrollPC,
  }),
  [SET_AUTOSHIP_COUNT]: (state, action) => {
    return state;
  },
  [SET_AUTOSHIP_INTERVAL]: (state, action) => {
    return state;
  },
  [SHOW_AUTOSHIP]: (state, { showAutoShip }) => ({
    ...state,
    showAutoShip,
  }),
  [RESET_CART]: (state, action) => ({
    ...state,
    ...action.cart,
  }),
};

export const togglePCEnroll = () => (dispatch, getState) => {
  const { enrollingAsPc, isUserPc } = getState().cart;
  if (isUserPc) return;

  dispatch({
    type: TOGGLE_PC_ENROLL,
    enrollingAsPc: !enrollingAsPc,
  });
  CartTogglePCMembershipMutation.commit({ environment });
};

export const togglePCAutoEnroll = () => ({
  type: TOGGLE_PC_AUTOENROLL,
});

export const showAutoShip = (bool: boolean) => ({
  type: SHOW_AUTOSHIP,
  showAutoShip: bool,
});

export const togglePCAutoship = ({ cart }) => (dispatch, getState) => {
  const { autoshipEnabled } = getState().cart;

  dispatch({
    type: TOGGLE_PC_AUTOSHIP,
    autoshipEnabled: !autoshipEnabled,
  });
  CartToggleAutoshipMutation.commit({ environment, cart, autoshipEnabled });
};

export const setAutoshipCount = ({ cart, autoShipIntervalCount }) => (
  dispatch,
  getState,
) => {
  dispatch({
    type: SET_AUTOSHIP_COUNT,
    autoShipIntervalCount,
  });
  CartAdjustAutoshipMutation.commit({
    cart,
    autoShipIntervalUnit: 'month',
    autoShipIntervalCount,
    environment,
  });
};
export const setAutoshipInterval = ({ cart, autoShipIntervalUnit }) => (
  dispatch,
  getState,
) => {
  const { autoShipIntervalCount } = getState().cart;
  dispatch({ type: SET_AUTOSHIP_INTERVAL, autoShipIntervalUnit });
  CartAdjustAutoshipMutation.commit({
    cart,
    autoShipIntervalUnit,
    autoShipIntervalCount,
    environment,
  });
};
export const addToCart = ({
  router,
  user,
  product,
  newQuantityTotalAfterQuantityChange,
  qtyChangeToApply,
  isCheckout,
  onCompleted,
  onError,
}) => (dispatch, getState) => {
  const { autoEnrollPC, autoshipEnabled } = getState().cart;
  const { cart } = user;

  const cartEntries = cart.entriesV2 || cart.entries;
  const pcInCart = cartEntries.edges.some(
    ({ node: cartEntry }) =>
      cartEntry.product && cartEntry.product.productId === PC_SUBSCRIPTION_ID,
  );
  const totalNumberOfItems = cart.viaQualifiedCartTotal;

  const isUserPC = user.conciergeUser
    ? user.conciergeUser.permissions.oneCommerce &&
      user.conciergeUser.permissions.oneCommerce.preferredCustomer &&
      user.conciergeUser.permissions.oneCommerce.preferredCustomer.access
    : user.permissions.oneCommerce &&
      user.permissions.oneCommerce.preferredCustomer &&
      user.permissions.oneCommerce.preferredCustomer.access;

  if (product && product.productId === MARIS_PICKS_SUBSCRIPTION_ID) {
    dispatch(showAutoShip());
    if (qtyChangeToApply < 0 && autoshipEnabled) {
      dispatch({
        type: TOGGLE_PC_AUTOSHIP,
        autoshipEnabled: false,
      });
    }
  }

  // add/remove PC membership to/from cart when (dis)qualified for savings
  if (
    autoEnrollPC &&
    qtyChangeToApply > 0 &&
    !isUserPC &&
    !pcInCart &&
    totalNumberOfItems + qtyChangeToApply >=
      MINIMUM_CART_QUANTITY_FOR_PC_AUTO_ENROLL
  ) {
    CartTogglePCMembershipMutation.commit({ environment });
  } else if (
    autoEnrollPC &&
    qtyChangeToApply < 0 &&
    !isUserPC &&
    pcInCart &&
    product.productId !== MARIS_PICKS_SUBSCRIPTION_ID &&
    totalNumberOfItems + qtyChangeToApply <
      MINIMUM_CART_QUANTITY_FOR_PC_AUTO_ENROLL
  ) {
    CartTogglePCMembershipMutation.commit({ environment });
  }

  CartAddMutation.commit(
    environment,
    router,
    user,
    product,
    newQuantityTotalAfterQuantityChange,
    qtyChangeToApply,
    isCheckout,
    !autoEnrollPC,
    onCompleted,
    onError,
  );
};

export const resetCart = cart => ({
  type: RESET_CART,
  cart,
});

export const mapStateToProps = ({ cart }) => ({
  ...cart,
});
export const mapDispatchToProps = {
  togglePCEnroll,
  togglePCAutoship,
  togglePCAutoEnroll,
  setAutoshipCount,
  setAutoshipInterval,
  resetCart,
  addToCart,
};

export default function reducer(state = initialState, action) {
  if (typeof ACTION_HANDLERS[action.type] === 'function') {
    return ACTION_HANDLERS[action.type](state, action);
  }

  return state;
}
